import { render, staticRenderFns } from "./SelectGenres.vue?vue&type=template&id=92788afa&"
import script from "./SelectGenres.vue?vue&type=script&lang=ts&"
export * from "./SelectGenres.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports